var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('render-content',{attrs:{"id":"contact"}}),_c('contact-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }